import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";
import ApiPath from "./ConstantApi/index";

export interface DashboardFilters {
  filters?: { key: string; value: any }[];
  granularity?: "daily" | "weekly" | "monthly";
  limit?: number;
}

export const DashboardApiService = createApi({
  reducerPath: "DashboardApi",
  baseQuery: RtkBaseQueryWithReauth(process.env.REACT_APP_BASE_URL || ""),
  tagTypes: ["Dashboard"],
  endpoints: (builder) => ({
    getDashboardSummary: builder.query<any, { startDate?: string; endDate?: string }>({
      query: (params) => ({
        url: `${ApiPath.dashboardSummary}?startDate=${params.startDate || ""}&endDate=${params.endDate || ""}`,
        method: "GET",
      }),
      providesTags: ["Dashboard"],
    }),

    getRevenueTrend: builder.mutation<any, DashboardFilters>({
      query: (body) => ({
        url: ApiPath.dashboardRevenueTrend,
        method: "POST",
        body,
      }),
    }),

    getOrdersTrend: builder.mutation<any, DashboardFilters>({
      query: (body) => ({
        url: ApiPath.dashboardOrdersTrend,
        method: "POST",
        body,
      }),
    }),

    getPaymentAnalytics: builder.mutation<any, DashboardFilters>({
      query: (body) => ({
        url: ApiPath.dashboardPaymentAnalytics,
        method: "POST",
        body,
      }),
    }),

    getTopProducts: builder.mutation<any, DashboardFilters>({
      query: (body) => ({
        url: ApiPath.dashboardTopProducts,
        method: "POST",
        body,
      }),
    }),

    getCustomerAnalytics: builder.mutation<any, DashboardFilters>({
      query: (body) => ({
        url: ApiPath.dashboardCustomerAnalytics,
        method: "POST",
        body,
      }),
    }),

    getRefundAnalytics: builder.mutation<any, DashboardFilters>({
      query: (body) => ({
        url: ApiPath.dashboardRefundAnalytics,
        method: "POST",
        body,
      }),
    }),

    getInventoryStatus: builder.query<any, void>({
      query: () => ({
        url: ApiPath.dashboardInventoryStatus,
        method: "GET",
      }),
    }),

    getRecentOrders: builder.mutation<any, DashboardFilters>({
      query: (body) => ({
        url: ApiPath.dashboardRecentOrders,
        method: "POST",
        body,
      }),
    }),

    getDeliveryStats: builder.mutation<any, DashboardFilters>({
      query: (body) => ({
        url: ApiPath.dashboardDeliveryStats,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetDashboardSummaryQuery,
  useLazyGetDashboardSummaryQuery,
  useGetRevenueTrendMutation,
  useGetOrdersTrendMutation,
  useGetPaymentAnalyticsMutation,
  useGetTopProductsMutation,
  useGetCustomerAnalyticsMutation,
  useGetRefundAnalyticsMutation,
  useGetInventoryStatusQuery,
  useLazyGetInventoryStatusQuery,
  useGetRecentOrdersMutation,
  useGetDeliveryStatsMutation,
} = DashboardApiService;
